export const validateModel = (value) => {
    if (!value) {
        return '';
    }
    const regex = /^[A-Za-z0-9 ]*$/;
    if (!regex.test(value)) {
        return 'No special characters allowed';
    }
    return '';
};